import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"

const CmsImage = ({ src, alt = "", objectFit }) => {
  if (!src) {
    return null
  }

  const image = getImage(
    src.hasOwnProperty("childImageSharp") ? src : src?.localImage
  )

  if (image) {
    /**
     * This is a gatsbyImageData object, we can use the optimized GatsbyImage
     */
    return <GatsbyImage {...{ image, alt: alt || "", objectFit }} />
  } else if (src?.url || src) {
    /**
     * if the image is not a gatsbyImageData object, then we search for
     * an image url. It might come from the cms live preview.
     */
    return (
      <div className="gatsby-image-wrapper">
        <img
          data-main-image
          src={src.url || src}
          alt={alt || ""}
          style={{ position: "static", opacity: 1 }}
        />
      </div>
    )
  } else {
    /**
     * we can't find any image here.
     */
    return null
  }
}

CmsImage.propTypes = {
  src: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  alt: PropTypes.string,
  objectFit: PropTypes.string,
}

export { CmsImage }
